// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2lF4M{font-size:14px;font-size:1.4rem;line-height:1.7;list-style:none;margin-bottom:4.8rem;margin-left:-4px;margin-right:-4px}._2lF4M>.col{padding-left:4px;padding-right:4px}._2WDpz{padding:0 4px 4px;position:relative}._2WDpz:after{background:#e0e8f2;border-radius:2px;bottom:0;content:\"\";height:4px;left:0;position:absolute;right:0}.luHcK:after{background:#452aec}._29EEZ:after{background:#14866e}.tPnFr{gap:16px;margin-bottom:16px}._33ubL,.tPnFr{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}._33ubL{height:84px;height:8.4rem;position:relative;width:84px;width:8.4rem;-ms-flex-pack:center;background:radial-gradient(closest-side,#fff 79%,transparent 80% 100%),conic-gradient(#004993 0,#004993 var(--progress),#d9dfe6 var(--progress),#d9dfe6 100%);border-radius:50%;justify-content:center}._3wpcu{text-align:center}", ""]);
// Exports
exports.locals = {
	"steps": "_2lF4M",
	"step": "_2WDpz",
	"step--active": "luHcK",
	"step--done": "_29EEZ",
	"wheelStepperContainer": "tPnFr",
	"wheelStepper": "_33ubL",
	"wheelStepper__text": "_3wpcu"
};
module.exports = exports;
